import { ReportMonthInput } from './ReportMonthInput';

export default ReportMonthInput;
